/* eslint-disable react/prop-types */
import styles from './styles.module.css'
import {
  ButtonFavoriteStarsPress,
  FavoriteStarsPress,
  NavigateArrowRigth,
  NumberFour,
  NumberOne,
  NumberThree,
  NumberTwo,
  Pen2,
  WhiteRefresh,
} from '../../../assets/svgs/icons'
import { useEffect, useState } from 'react'
import ModalComponent from '../../../components/ModalComponent'
import CalendarModal from '../../../components/CalendarModal'
import { SelectRound } from '../../../components/Select/SelectRound'
import { useNavigate } from 'react-router-dom'
import { getLegendsService } from '../../../services/postsServices/getLegendsService'
import Loading from '../../../components/Loading'
import {
  BrandingService,
  BusinessService,
  ProductService,
  TargetAudienceService,
  VoiceToneService,
  HeadlineHasPublicationService,
  PythonService,
  EditorialLineService,
  UserPlanCount,
  SubscriptionService,
  OrchestratorTextGenerationService,
} from '../../../services'
import { useClient } from '../../../hooks/useClient'
import { getBusinessByClientId } from '../../../services/business'
// import { ProductFruits } from 'react-product-fruits'
import { useTranslation } from 'react-i18next'
import { notifyErrorCustom, notifyWarningCustom } from '../../../utils/notify'
import { postPromptGPT } from '../../../services/pythonService'

const STEPS = {
  STEP_THIRD_PASS_PUBLICATION: 'stepPublication',
}

function StepFourthPass({
  setStep,
  iWantPublicationRef,
  targetAudienceRef,
  productRef,
  publicationFormatRef,
  purposeOfPublicationRef,
  publicationDraft,
  publicationRet,

  imageUrl,
  imageLayers,
  setImageUrl,
  headlineText,
  setHeadlineText,
  legend,
  setLegend,

  draftData,
  draft,
  repost,
  schedule,

  setHeadlineList,
  headlineList,
  setLegendList,
  legendList,
  selectFunnel,
  headlineGpt,
  setCurrentIndex,
  publicationDescriptionRef,

  //dados da tela anterior
}) {
  const navigate = useNavigate()
  const nextButton = async (navigation) => {
    if (draft) {
      navigate('/Draft')
      return
    }
    if (repost) {
      navigate('/History')
      return
    }
    if (schedule) {
      navigate('/SchedulePublicationPage')
      return
    }
    if (navigation === 'back') {
      setStep(STEPS.STEP_THIRD_PASS_PUBLICATION)
    }
  }

  const [gptInput, setGptInput] = useState('')

  const [isModalOpen, setModalOpen] = useState(false)

  const [loading, setLoading] = useState(false)

  const { clientData } = useClient()

  const { t } = useTranslation()

  const items = [
    {
      id: 1,
      image:
        'https://i.pinimg.com/564x/db/63/29/db6329626b8a4fa34ef798bfa2d48708.jpg',
      title: 'Quer vender seu carro? Nós compramos ele',
      text: 'Lorem ipsum dolor sit amet consectetur. In quam sed ultrices elementum facilisis. Eu ornare ut lectus porttitor augue. Etiam mattis ut volutpat sem sed sed etiam. Nunc enim semper convallis quis non pellentesque. Tellus et tempor neque in ullamcorper turpis malesuada purus faucibus. Sit accumsan ac arcu arcu ultrices malesuada diam elit. Cras quis at vulputate rhoncus urna augue pulvinar tortor. Turpis fermentum velit proin morbi gravida dapibus lorem. Rhoncus donec at ultrices non.      Mauris placerat eget id ut lorem commodo. Eget consectetur arcu bibendum nisl. Tristique senectus elit aenean sollicitudin.',
      avaliacao: 5,
      // pinterest: {
      //   active: false,
      //   orientation: 2,
      // },
      linkedin: {
        active: true,
        orientation: null,
      },
      facebook: {
        active: true,
        orientation: null,
      },
      instagram: {
        active: true,
        orientation: null,
      },
      tiktok: {
        active: true,
        orientation: null,
      },
      twitter: {
        active: true,
        orientation: null,
      },
    },
  ]

  useEffect(() => {
    if (draft === false && repost === false && schedule === false) {
      legendGenerate()
    }
  }, [])

  const legendGenerate = async () => {
    setLoading(true)

    const userPlanCount = await UserPlanCount.getUserPlanCountByUser()
    const userSubscription = await SubscriptionService.getSubscriptionByUser()
    const mesAtual = new Date(new Date().setDate(1)) // Primeiro dia do mês atual
    mesAtual.setDate(mesAtual.getDate() + 30)
    mesAtual.setHours(0, 0, 0, 0)

    if (!userPlanCount.data) {
      const postUserPlanCount = await UserPlanCount.postUserPlanCount({
        ownScheduleCount: 0,
        postOnDesignCount: 0,
        imageBankCount: 0,
        aiImageCount: 0,
        aiLegendCount: 1,
        aiMessageCount: 0,
        renewalDate:
          userSubscription.data.length > 0
            ? userSubscription.data[0].expiration
            : mesAtual,
      })
    } else {
      const renewalDate = new Date(userPlanCount.data.renewalDate)
      const dataAtual = new Date()

      const expirationPlan =
        userSubscription.data.length > 0
          ? new Date(userSubscription.data[0].expiration)
          : new Date(mesAtual)

      if (
        renewalDate.getTime() < dataAtual.getTime() ||
        renewalDate.getTime() != expirationPlan.getTime()
      ) {
        await UserPlanCount.postUserPlanCount({
          ownScheduleCount: 0,
          postOnDesignCount: 0,
          imageBankCount: 0,
          aiImageCount: 0,
          aiLegendCount: 1,
          aiMessageCount: 0,
          renewalDate:
            userSubscription.data.length > 0
              ? userSubscription.data[0].expiration
              : mesAtual,
        })
      } else {
        if (
          userSubscription.data.length <= 0 &&
          userPlanCount.data.aiLegendCount >= 40
        ) {
          notifyWarningCustom(t('plans.user_plan_count_legend'))
          setLoading(false)
          return
        } else if (userSubscription.data.length > 0) {
          const index = await userSubscription.data[0].Plan.PlanItems.findIndex(
            (item) => item.type === 'ia_legend_generative_quantity'
          )
          const quantityLegendst =
            userSubscription.data[0].Plan.PlanItems[index]?.quantity

          if (
            userPlanCount.data.aiLegendCount >= quantityLegendst &&
            quantityLegendst != null
          ) {
            notifyWarningCustom(t('plans.user_plan_count_legend'))
            setLoading(false)
            return
          }
        }
        await UserPlanCount.putUserPlanCount(userPlanCount.data.uuid, {
          ownScheduleCount: userPlanCount.data.ownScheduleCount,
          postOnDesignCount: userPlanCount.data.postOnDesignCount,
          imageBankCount: userPlanCount.data.imageBankCount,
          aiImageCount: userPlanCount.data.aiImageCount,
          aiLegendCount: userPlanCount.data.aiLegendCount + 1,
          aiMessageCount: userPlanCount.data.aiMessageCount,
          renewalDate: userPlanCount.data.renewalDate,
        })
      }
    }

    let getEditorialLine
    let editorialLine

    if (clientData?.uuid) {
      getEditorialLine = await EditorialLineService.getEditorialLineByClient(
        clientData?.uuid
      )
      editorialLine = getEditorialLine.data[0].bodyJson
    } else {
      getEditorialLine = await EditorialLineService.getEditorialLinebyLogin()
      editorialLine = getEditorialLine.data[0].bodyJson
    }

    const bodyLegend = {
      flow: 'unique_publication',
      prompt: 'legend',
      post_description: publicationDescriptionRef.current, //editorialLine.dados_da_marca.descricao_negocio,
      brand: editorialLine.dados_da_marca.nicho,
      funil: selectFunnel,
      niche: editorialLine.dados_da_marca.nicho,
      subniche: editorialLine.dados_da_marca.subnicho,
      business_description: editorialLine.dados_da_marca.descricao_negocio,
      target_public: {
        name: targetAudienceRef?.current?.name || '',
        gender: targetAudienceRef?.current?.genderValue || '',
        social_class:
          targetAudienceRef?.current?.socialClassValue?.join(', ') || '',
        profession: targetAudienceRef?.current?.profession || '',
        region: 'Nacional, com foco em grandes centros urbanos',
      },
      voice_tone: editorialLine.tom_de_voz ?? 'Alegre',
      voice_tone_description: editorialLine.tipo_post,
      product: {
        name: productRef?.current?.name || '',
        type: productRef?.current?.productTypeValue || '',
        description: productRef?.current?.description || '',
        value: productRef?.current?.price || '',
        promotional_value: productRef?.current?.promotionalValue || '',
      },
      headlines: headlineGpt.data.data.headlines,
      language:
        localStorage.i18nextLng == 'en' ? localStorage.i18nextLng : 'pt',
    }

    // let retEditorialLine = await PythonService.postPromptGPT(bodyLegend)
    let retEditorialLine = await OrchestratorTextGenerationService.generateLegend(bodyLegend)

    // let businessId
    // let descriptionBusines
    // let productInfos = ''
    // let targetAudiencesInfos = ''

    // if (clientData?.uuid) {
    //   const { data } = await getBusinessByClientId(clientData?.uuid)
    //   businessId = data[0]?.uuid
    //   descriptionBusines = data[0]?.description
    // } else {
    //   const { data } = await BusinessService.getBusinessByLogin()
    //   businessId = data[0]?.uuid
    //   descriptionBusines = data[0]?.description
    // }

    // // console.log('150', targetAudienceRef?.current)

    // if (productRef?.current) {
    //   productInfos = await ProductService.getProductById(
    //     productRef?.current?.uuid
    //   )
    // }

    // const voiceToneInfos = await VoiceToneService.getVoiceToneByBusiness(
    //   businessId
    // )
    // // const businessInfos = await BusinessService.getBusinessByLogin()

    // if (targetAudienceRef?.current) {
    //   targetAudiencesInfos =
    //     await TargetAudienceService.getAllTargetAudienceById(
    //       targetAudienceRef?.current?.uuid
    //     )
    // }

    // const bodyLegend = {
    //   headlineSelected: headlineText,
    //   publicationPurpose: purposeOfPublicationRef?.current
    //     ? purposeOfPublicationRef?.current
    //     : '',
    //   descriptionBusiness: descriptionBusines,
    //   voiceTone: voiceToneInfos?.data[0]?.tone,
    //   socialClass: targetAudiencesInfos
    //     ? targetAudiencesInfos?.data[0]?.educationLevelValue
    //     : '',
    //   gender: targetAudiencesInfos
    //     ? targetAudiencesInfos?.data[0]?.genderValue
    //     : '',
    //   profession: targetAudiencesInfos
    //     ? targetAudiencesInfos?.data[0]?.profession
    //     : '',
    //   nameProduct: productInfos ? productInfos?.data?.name : '',
    //   productType: productInfos ? productInfos?.data?.productTypeValue : '',
    //   productDescription: productInfos ? productInfos?.data?.description : '',
    //   value: productInfos ? productInfos?.data?.value : '',
    //   promotionalValue: productInfos
    //     ? productInfos?.data?.promotionalValue
    //     : '',
    // }

    // const data = await getLegendsService(bodyLegend)

    //setLegend(data.message)
    setLegend(retEditorialLine.data.data[0])

    setLoading(false)
  }

  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const stars = [...new Array(5).keys()]

  const [activeIndex, setActiveIndex] = useState()

  const onClickStar = (index) => {
    setActiveIndex((oldState) => (oldState == index ? undefined : index))
  }

  useEffect(() => {
    setCurrentIndex(activeIndex ? activeIndex + 1 : 0)
  }, [activeIndex])

  const [activeImputLegend, setActiveImputLegend] = useState(false)

  const handleLegendChange = (e) => {
    setLegend(e)
  }

  const legendUpdate = () => {
    setActiveImputLegend(!activeImputLegend)
  }

  const storage = JSON.parse(window.localStorage.getItem('userData')).userEmail
  const userInfo = {
    username: storage, // REQUIRED, must be unique
  }

  const loadGptOutput = async () => {
    const userPlanCount = await UserPlanCount.getUserPlanCountByUser()
    const userSubscription = await SubscriptionService.getSubscriptionByUser()
    const mesAtual = new Date(new Date().setDate(1)) // Primeiro dia do mês atual
    mesAtual.setDate(mesAtual.getDate() + 30)
    mesAtual.setHours(0, 0, 0, 0)

    if (!userPlanCount.data) {
      const postUserPlanCount = await UserPlanCount.postUserPlanCount({
        ownScheduleCount: 0,
        postOnDesignCount: 0,
        imageBankCount: 0,
        aiImageCount: 0,
        aiLegendCount: 1,
        aiMessageCount: 0,
        renewalDate:
          userSubscription.data.length > 0
            ? userSubscription.data[0].expiration
            : mesAtual,
      })
    } else {
      const renewalDate = new Date(userPlanCount.data.renewalDate)
      const dataAtual = new Date()

      const expirationPlan =
        userSubscription.data.length > 0
          ? new Date(userSubscription.data[0].expiration)
          : new Date(mesAtual)

      if (
        renewalDate.getTime() < dataAtual.getTime() ||
        renewalDate.getTime() != expirationPlan.getTime()
      ) {
        await UserPlanCount.postUserPlanCount({
          ownScheduleCount: 0,
          postOnDesignCount: 0,
          imageBankCount: 0,
          aiImageCount: 0,
          aiLegendCount: 1,
          aiMessageCount: 0,
          renewalDate:
            userSubscription.data.length > 0
              ? userSubscription.data[0].expiration
              : mesAtual,
        })
      } else {
        if (
          userSubscription.data.length <= 0 &&
          userPlanCount.data.aiLegendCount >= 40
        ) {
          notifyWarningCustom(t('plans.user_plan_count_legend'))
          setLoading(false)
          return
        } else if (userSubscription.data.length > 0) {
          const index = await userSubscription.data[0].Plan.PlanItems.findIndex(
            (item) => item.type === 'ia_legend_generative_quantity'
          )
          const quantityLegendst =
            userSubscription.data[0].Plan.PlanItems[index]?.quantity

          if (
            userPlanCount.data.aiLegendCount >= quantityLegendst &&
            quantityLegendst != null
          ) {
            notifyWarningCustom(t('plans.user_plan_count_legend'))
            setLoading(false)
            return
          }
        }
        await UserPlanCount.putUserPlanCount(userPlanCount.data.uuid, {
          ownScheduleCount: userPlanCount.data.ownScheduleCount,
          postOnDesignCount: userPlanCount.data.postOnDesignCount,
          imageBankCount: userPlanCount.data.imageBankCount,
          aiImageCount: userPlanCount.data.aiImageCount,
          aiLegendCount: userPlanCount.data.aiLegendCount + 1,
          aiMessageCount: userPlanCount.data.aiMessageCount,
          renewalDate: userPlanCount.data.renewalDate,
        })
      }
    }

    let businesData = undefined
    let voiceToneData = ''

    if (clientData?.uuid) {
      const { data } = await getBusinessByClientId(clientData?.uuid)
      businesData = data[0]

      voiceToneData = await VoiceToneService.getAllVoiceToneByBusinessId(
        businesData?.uuid
      )
    } else {
      const { data } = await BusinessService.getBusinessByLogin()

      businesData = data[0]

      voiceToneData = await VoiceToneService.getAllVoiceToneByBusiness()
    }

    // console.log('voiceToneData ====> ', voiceToneData?.data[0]?.tone)

    const body = {
      flow: 'own_publication',
      prompt: 'legend',

      niche: businesData?.BusinessNiche?.name,
      subniche: businesData?.subNiche,
      input: gptInput,
      voice_tone: voiceToneData?.data[0]?.tone ?? 'Alegre',
      business_description: businesData?.description,
    }

    // console.log('body ====> ', body)

    // const response = await postPromptGPT(body)
    const response = await OrchestratorTextGenerationService.generateLegend(body)

    // console.log('response ====> ', response)

    if (response?.data?.status === 200) {
      const rawLegend = response?.data?.data?.text || response?.data?.data?.legenda || ''
      let legend = rawLegend
      try {
        const parsed = JSON.parse(rawLegend)
        if (parsed && typeof parsed.legenda === 'string') {
          legend = parsed.legenda
        }
      } catch {
        // não é JSON, manter texto puro
      }
      setLegend(legend)
    } else {
      notifyErrorCustom('Erro ao gerar legenda!')
    }

    setLoading(false)
  }

  return (
    <div className={styles.container_page}>
      <Loading enable={loading} />
      {/* <ProductFruits
        workspaceCode="FzMKHdjfiHGoWeMW"
        language="en"
        user={userInfo}
      /> */}
      <div className={styles.title_new_posts}>
        <p className={styles.title_new_posts_label}>Nova </p>
        <p className={styles.title_new_posts_title}>Publicação</p>
      </div>
      <div className={styles.title_steps}>
        <div className={styles.previous_pass}>
          <div>
            <NumberOne width={'50px'} height={'50px'} />
          </div>
          <div className={styles.first_pass_title}>
            <p className={styles.first_pass_title_text}>
              {t('new_publication_page_first_pass_pass')}
            </p>
            <p className={styles.first_pass_subtitle}>
              {t('new_publication_page_first_pass_title')}
            </p>
          </div>
        </div>

        <div className={styles.previous_pass}>
          <div className={styles.second_pass_box_number}>
            <NavigateArrowRigth />
            <NumberTwo width={'50px'} height={'50px'} />
          </div>
          <div>
            <p className={styles.first_pass_title_text}>
              {t('new_publication_page_second_pass_pass')}
            </p>
            <p className={styles.first_pass_subtitle}>
              {t('new_publication_page_second_pass_title')}
            </p>
          </div>
        </div>

        <div className={styles.previous_pass}>
          <div className={styles.second_pass_box_number}>
            <NavigateArrowRigth />
            <NumberThree width={'50px'} height={'50px'} />
          </div>
          <div>
            <p className={styles.first_pass_title_text}>
              {t('new_publication_page_third_pass_pass')}
            </p>
            <p className={styles.first_pass_subtitle}>
              {t('new_publication_page_third_pass_title')}
            </p>
          </div>
        </div>

        <div className={styles.current_pass}>
          <div className={styles.second_pass_box_number}>
            <NavigateArrowRigth />
            <NumberFour width={'50px'} height={'50px'} />
          </div>
          <div>
            <p className={styles.first_pass_title_text}>
              {t('new_publication_page_fourth_pass_pass')}
            </p>
            <p className={styles.first_pass_subtitle}>
              {t('new_publication_page_fourth_pass_title')}
            </p>
          </div>
        </div>

        <div className={styles.next_pass}>
          <NavigateArrowRigth />
        </div>
      </div>
      <div className={styles.container_content}>
        {items.map((item, index) => (
          <div key={item.id} className={styles.container_image_example}>
            <div className={styles.box_image}>
              <img
                src={imageUrl}
                alt=""
                className={styles.image}
              //onContextMenu={(e) => e.preventDefault()}
              />
            </div>
            <div className={styles.box_subtitle}>
              {/* <p className={styles.box_subtitle_title}>
                {headlineList[index] ? headlineList[index] : headlineText}
              </p> */}
              {/* <div className={styles.box_select}>
                <SelectRound
                  htmlFor="select"
                  placeholder="Selecione"
                  defaultSelected={{
                    label: 'Selecione o tipo de publicação',
                    value: '',
                  }}
                  options={[
                    { label: 'Teste', value: 1 },
                    { label: 'Teste2', value: 2 },
                  ]}
                />
              </div> */}

              {/* <div className={styles.box_button_subtitle_refresh}>
                <div
                  className={styles.button_subtitle_refresh}
                  onClick={() => legendGenerate()}
                >
                  <WhiteRefresh width={'24px'} height={'24px'} />
                </div>

                <div
                  className={styles.button_subtitle_refresh}
                  onClick={() => legendUpdate()}
                >
                  <Pen2 color="#190027" width={'24px'} height={'24px'} />
                </div>
              </div> */}

              {/* <div className={styles.box_description_post}>
               
                <textarea
                  className={
                    !activeImputLegend
                      ? styles.input_legend_readOnly
                      : styles.input_legend
                  }
                  readOnly={!activeImputLegend}
                  name=""
                  id=""
                  cols="30"
                  rows="10"
                  onChange={(e) => handleLegendChange(e.target.value)}
                  value={legend}
                />
              </div> */}

              <div
                style={{
                  marginTop: 30,

                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                  cursor: 'default',
                }}
              // className={styles.selectedModalCard}
              >
                <div
                  className={styles.form_container_input}
                  style={{
                    cursor: 'default',
                  }}
                >
                  <label
                    style={{
                      fontSize: 14,
                      color: '#190027',
                      fontWeight: 500,
                    }}
                  >
                    {t('stepMyPublication.legend')}
                  </label>

                  <textarea
                    readOnly={false}
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    value={legend || ''}
                    style={{
                      width: '100%',
                      height: 130,
                      borderRadius: 6,
                      border: '1px solid #ededed',
                      backgroundColor: 'rgba(224, 224, 224, 1)',
                      padding: '10px',
                      color: '#373737',
                      resize: 'none',
                      outline: 'none',
                      fontFamily: 'Poppins',
                      fontSize: 16,
                    }}
                    onChange={(e) => handleLegendChange(e.target.value, index)}
                    placeholder={t('stepMyPublication.legendPlaceholder')}
                  />

                  <div
                    style={{
                      display: 'flex',
                      gap: 20,
                    }}
                  >
                    <input
                      // value={gptInput}
                      onChange={(e) => setGptInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          setLoading(true)
                          loadGptOutput()
                        }
                      }}
                      type="text"
                      placeholder={t('legendPlaceholder')}
                      style={{
                        width: '100%',
                        height: 40,
                        borderRadius: 5,
                        border: '1px solid #ededed',
                        backgroundColor: '#ededed',
                        padding: '0 10px',
                        marginTop: 10,
                        marginBottom: 20,

                        color: '#190027',
                      }}
                    />
                    <div
                      onClick={() => {
                        setLoading(true)
                        loadGptOutput()
                      }}
                      style={{
                        display: 'flex',
                        marginTop: 10,
                        height: 40,
                        width: 100,
                        borderRadius: 5,
                        backgroundColor: '#6A0098',

                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <div
                        style={{
                          color: '#fff',
                          textAlign: 'center',
                          fontSize: 14,
                        }}
                      >
                        {t('stepMyPublication.apply')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.box_avaliacao}>
                {/* {[...Array(items[currentIndex].avaliacao)].map((_, index) => (
                  ))} */}
                {stars.map((index) => (
                  <ButtonFavoriteStarsPress
                    key={`star_${index}`}
                    color={'#000'}
                    isActive={index <= activeIndex}
                    onClick={() => onClickStar(index)}
                  />
                ))}
              </div>
            </div>

            <ModalComponent isOpen={isModalOpen} onClose={handleCloseModal}>
              <CalendarModal
                handleCloseModal={handleCloseModal}
                item={item}
                purposeOfPublicationRef={purposeOfPublicationRef}
                publicationFormatRef={publicationFormatRef}
                productRef={productRef}
                targetAudienceRef={targetAudienceRef}
                iWantPublicationRef={iWantPublicationRef}
                imageUrl={imageUrl}
                imageLayers={imageLayers}
                setImageUrl={setImageUrl}
                headlineText={headlineText}
                setHeadlineText={setHeadlineText}
                legend={legend}
                setHeadlineList={setHeadlineList}
                headlineList={headlineList}
                setLegendList={setLegendList}
                legendList={legendList}
                //dados da tela anterior
                draftModalData={draftData}
              />
            </ModalComponent>
          </div>
        ))}
      </div>
      <div className={styles.button_nav}>
        <button
          className={styles.button_back}
          onClick={() => {
            // nextButton('back')
            setStep('stepArts')
          }}
        >
          <p className={styles.button_title}>{t('back_buttom')}</p>
        </button>

        <div
          style={{
            display: 'flex',
            gap: '10px',
            pasition: 'fixed',
          }}
        >
          <button
            className={styles.button_next}
            onClick={() => {
              setStep('stepFinish')
            }}
          >
            <p className={styles.button_title}>
              {t('new_publication_page_fourth_pass_finish_scheduling')}
            </p>
          </button>

          {/* <button className={styles.button_next} onClick={handleOpenModal}>
            <p className={styles.button_title}>Finalizar agendamento</p>
          </button> */}
        </div>
      </div>
    </div>
  )
}

export default StepFourthPass
